function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgRunning(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M20.262 7.426a2.71 2.71 0 002.709-2.713A2.71 2.71 0 0020.262 2a2.71 2.71 0 00-2.709 2.713 2.71 2.71 0 002.709 2.713zM27.832 14.722l-5.174 2.86a1.118 1.118 0 01-1.25-.114 1.151 1.151 0 01-.335-.474l-.986-2.496-.96 3.55a.737.737 0 00.262.775l4.702 3.622c.56.43.663 1.23.234 1.79l-.017.02a1.29 1.29 0 01-.338.317l-7.258 4.64a1.269 1.269 0 01-1.785-.43c-.352-.599-.13-1.374.454-1.747l5.73-3.664-4.64-3.27a.52.52 0 00-.795.265l-1.81 5.545a1.27 1.27 0 01-.346.77L8.2 32.292a1.271 1.271 0 01-1.802.046 1.277 1.277 0 01-.048-1.805l5.072-5.346c1.324-4.719 2.65-9.436 3.975-14.153l-2.584.225-.644 5.022a1.116 1.116 0 11-2.213-.276l.75-5.885c.063-.508.462-.907.97-.97l5.544-.695c.271-.063 1.26-.266 2.27.281.617.334.97.8 1.139 1.061l2.061 5.216 4.097-2.266a1.116 1.116 0 011.578.57c.21.526-.036 1.129-.533 1.404z",
    fill: props.fill
  }));
}

export default SvgRunning;